import { CancellationToken } from 'monaco-editor/esm/vs/base/common/cancellation.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import { Disposable, toDisposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const IWebviewViewService = ( createDecorator('webviewViewService'));
class WebviewViewService extends Disposable {
    constructor() {
        super(...arguments);
        this._resolvers = ( new Map());
        this._awaitingRevival = ( new Map());
        this._onNewResolverRegistered = this._register(( new Emitter()));
        this.onNewResolverRegistered = this._onNewResolverRegistered.event;
    }
    register(viewType, resolver) {
        if (( this._resolvers.has(viewType))) {
            throw new Error(`View resolver already registered for ${viewType}`);
        }
        this._resolvers.set(viewType, resolver);
        this._onNewResolverRegistered.fire({ viewType: viewType });
        const pending = this._awaitingRevival.get(viewType);
        if (pending) {
            resolver.resolve(pending.webview, CancellationToken.None).then(() => {
                this._awaitingRevival.delete(viewType);
                pending.resolve();
            });
        }
        return toDisposable(() => {
            this._resolvers.delete(viewType);
        });
    }
    resolve(viewType, webview, cancellation) {
        const resolver = this._resolvers.get(viewType);
        if (!resolver) {
            if (( this._awaitingRevival.has(viewType))) {
                throw new Error('View already awaiting revival');
            }
            let resolve;
            const p = ( new Promise(r => resolve = r));
            this._awaitingRevival.set(viewType, { webview, resolve: resolve });
            return p;
        }
        return resolver.resolve(webview, cancellation);
    }
}
export { IWebviewViewService, WebviewViewService };
